export default function (_ref) {
  var _theme$components;

  let {
    theme
  } = _ref;
  let cssRoot = {},
      cssSearchFieldWrapper = {},
      cssButtonControlWrapper = {};
  const findby = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.findby;

  if (findby) {
    cssRoot = findby.root;
    cssSearchFieldWrapper = findby.searchFieldWrapper;
    cssButtonControlWrapper = findby.buttonControlWrapper;
  }

  return {
    cssRoot,
    cssSearchFieldWrapper,
    cssButtonControlWrapper
  };
}